import { render, staticRenderFns } from "./StudentAttendanceView.vue?vue&type=template&id=5b847ace&scoped=true"
import script from "./StudentAttendanceView.vue?vue&type=script&lang=js"
export * from "./StudentAttendanceView.vue?vue&type=script&lang=js"
import style0 from "./StudentAttendanceView.vue?vue&type=style&index=0&id=5b847ace&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b847ace",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
